import { EmergencyLightingOnEveryFloorStatus, FireEvacuationStatus, FireExtinguisherInElevatorRoomStatus, FireExtinguisherOnEveryFloorStatus, FireHoseReelStatus, FireProofDoorsStatus, FireSecurityBuildingInfoDto, FireStairStatus, SmokeDetectorsOnEveryFloorStatus } from "shared/types/fire-security";

// Calculate the date for 3 months from now
const threeMonthsFromNow = new Date();
threeMonthsFromNow.setMonth(threeMonthsFromNow.getMonth() + 3);

const nineMonthsBefore = new Date();
nineMonthsBefore.setMonth(nineMonthsBefore.getMonth() - 9);

const twelveMonthsBefore = new Date();
twelveMonthsBefore.setMonth(twelveMonthsBefore.getMonth() - 12);


const now = new Date();


export const calculateFireSecurityBuildingDotValues = (fireSecurityBuildingInfo: FireSecurityBuildingInfoDto) => {
    let dotValues: any = {
        red: { count: 0, labels: [] },
        orange: { count: 0, labels: [] },
        green: { count: 0, labels: [] },
        transparent: { count: 0, labels: [] },
    };

    // Transparent values
    if (!fireSecurityBuildingInfo || !fireSecurityBuildingInfo.fireEvacuationStatus || fireSecurityBuildingInfo.fireEvacuationStatus === FireEvacuationStatus.UNKNOWN) {
        dotValues.transparent.count++;
        dotValues.transparent.labels.push("Niet bekend of er evacuatie aanduidingen zijn");
    } 
    if (!fireSecurityBuildingInfo || !fireSecurityBuildingInfo.smokeDetectorsOnEveryFloorStatus || fireSecurityBuildingInfo.smokeDetectorsOnEveryFloorStatus === SmokeDetectorsOnEveryFloorStatus.UNKNOWN){
        dotValues.transparent.count++;
        dotValues.transparent.labels.push("Niet bekend of er rookmelders zijn");
    } 
    if (!fireSecurityBuildingInfo || !fireSecurityBuildingInfo.emergencyLightingOnEveryFloorStatus || fireSecurityBuildingInfo.emergencyLightingOnEveryFloorStatus === EmergencyLightingOnEveryFloorStatus.UNKNOWN) {
        dotValues.transparent.count++;
        dotValues.transparent.labels.push("Niet bekend of er noodverlichting is");
    } 
    if (!fireSecurityBuildingInfo || !fireSecurityBuildingInfo.fireExtinguisherOnEveryFloorStatus || fireSecurityBuildingInfo.fireExtinguisherOnEveryFloorStatus === FireExtinguisherOnEveryFloorStatus.UNKNOWN) {
        dotValues.transparent.count++;
        dotValues.transparent.labels.push("Niet bekend of er brandblussers zijn");
    } 
    if (!fireSecurityBuildingInfo || !fireSecurityBuildingInfo.fireExtinguisherInElevatorRoomStatus || fireSecurityBuildingInfo.fireExtinguisherInElevatorRoomStatus === FireExtinguisherInElevatorRoomStatus.UNKNOWN) {
        dotValues.transparent.count++;
        dotValues.transparent.labels.push("Niet bekend of er een brandblusser in de liftkamer is");
    } 
    if (!fireSecurityBuildingInfo || !fireSecurityBuildingInfo.fireProofDoors || fireSecurityBuildingInfo.fireProofDoors === FireProofDoorsStatus.UNKNOWN) {
        dotValues.transparent.count++;
        dotValues.transparent.labels.push("Niet bekend of er brandveilige deuren zijn");
    } 
    if (!fireSecurityBuildingInfo || !fireSecurityBuildingInfo.fireHoseReelStatus || fireSecurityBuildingInfo.fireHoseReelStatus === FireHoseReelStatus.UNKNOWN) {
        dotValues.transparent.count++;
        dotValues.transparent.labels.push("Niet bekend of er brandhaspels zijn");
    } 
    if (!fireSecurityBuildingInfo || !fireSecurityBuildingInfo.inspectorResourceId) {
        dotValues.transparent.count++;
        dotValues.transparent.labels.push("Niet bekend welke partij het brandonderhoud heeft gedaan");
    } 
    if (!fireSecurityBuildingInfo || !fireSecurityBuildingInfo.fireStairStatus || fireSecurityBuildingInfo.fireStairStatus === FireStairStatus.UNKNOWN) {
        dotValues.transparent.count++;
        dotValues.transparent.labels.push("Niet bekend of er een brandtrap is");
    } 

    if (!fireSecurityBuildingInfo.fireSecurityLastInspectionDate) {
        dotValues.transparent.count++;
        dotValues.transparent.labels.push("Niet wanneer de laatste inspectie is uitgevoerd");
    } 
    if (!fireSecurityBuildingInfo.fireSecurityNextInspectionDate) {
        dotValues.transparent.count++;
        dotValues.transparent.labels.push("Niet wanneer de volgende inspectie nodig is");
    } 

    // Orange values
    if (fireSecurityBuildingInfo.fireEvacuationStatus === FireEvacuationStatus.PARTIAL) {
        dotValues.orange.count++;
        dotValues.orange.labels.push("Evacuatie aanduidingen gedeeltelijk in orde");
    } 
    if (fireSecurityBuildingInfo.smokeDetectorsOnEveryFloorStatus === SmokeDetectorsOnEveryFloorStatus.PARTIAL) {
        dotValues.orange.count++;
        dotValues.orange.labels.push("Rookdetectoren maar in orde");
    } 
    if (fireSecurityBuildingInfo.emergencyLightingOnEveryFloorStatus === EmergencyLightingOnEveryFloorStatus.PARTIAL){
        dotValues.orange.count++;
        dotValues.orange.labels.push("Noodverlichting gedeeltelijk in orde");
    } 
    if (fireSecurityBuildingInfo.fireExtinguisherOnEveryFloorStatus === FireExtinguisherOnEveryFloorStatus.PARTIAL) {
        dotValues.orange.count++;
        dotValues.orange.labels.push("Brandblussers gedeeltelijk in orde");
    } 
    if (fireSecurityBuildingInfo.fireSecurityLastInspectionDate) {
        const lastInspectionDate = new Date(fireSecurityBuildingInfo.fireSecurityLastInspectionDate);
        if (lastInspectionDate < new Date() && lastInspectionDate < nineMonthsBefore) {
            dotValues.orange.count++;
            dotValues.orange.labels.push("Laatste inspectiedatum is al meer dan 9 maanden geleden");
        } 
    }

    if (fireSecurityBuildingInfo.fireSecurityLastInspectionDate) {
        const expirationDate = new Date(fireSecurityBuildingInfo.fireSecurityNextInspectionDate);
        if (expirationDate > new Date() && expirationDate <= threeMonthsFromNow){
            dotValues.orange.count++;
            dotValues.orange.labels.push("Volgende inspectiedatum komt er aan");
        } 
    }

    // Red values
    if (fireSecurityBuildingInfo.emergencyLightingOnEveryFloorStatus === EmergencyLightingOnEveryFloorStatus.NOT_OK) {
        dotValues.red.count++;
        dotValues.red.labels.push("Noodverlichting op elke verdieping is niet in orde");
    }
    if (fireSecurityBuildingInfo.smokeDetectorsOnEveryFloorStatus === SmokeDetectorsOnEveryFloorStatus.NOT_OK) {
        dotValues.red.count++;
        dotValues.red.labels.push("Rookmelders op elke verdieping zijn niet in orde");
    }
    if (fireSecurityBuildingInfo.fireExtinguisherOnEveryFloorStatus === FireExtinguisherOnEveryFloorStatus.NOT_OK) {
        dotValues.red.count++;
        dotValues.red.labels.push("Brandblussers op elke verdieping zijn niet in orde");
    }
    if (fireSecurityBuildingInfo.fireExtinguisherInElevatorRoomStatus === FireExtinguisherInElevatorRoomStatus.NOT_OK) {
        dotValues.red.count++;
        dotValues.red.labels.push("Brandblusser in liftkamer is niet in orde");
    }
    if (fireSecurityBuildingInfo.fireHoseReelStatus === FireHoseReelStatus.NOT_OK) {
        dotValues.red.count++;
        dotValues.red.labels.push("Brandslanghaspel is niet in orde");
    }
    if (fireSecurityBuildingInfo.fireProofDoors === FireProofDoorsStatus.NOT_OK) {
        dotValues.red.count++;
        dotValues.red.labels.push("Brandwerende deuren zijn niet in orde");
    }
    if (fireSecurityBuildingInfo && fireSecurityBuildingInfo.fireStairStatus && fireSecurityBuildingInfo.fireStairStatus === FireStairStatus.NOT_OK) {
        dotValues.transparent.count++;
        dotValues.transparent.labels.push("Brandtrap verplicht, maar niet aanwezig");
    } 

    if (fireSecurityBuildingInfo.fireSecurityLastInspectionDate) {
        const lastInspectionDate = new Date(fireSecurityBuildingInfo.fireSecurityLastInspectionDate);
        if (lastInspectionDate < twelveMonthsBefore) {
            dotValues.red.count++;
            dotValues.red.labels.push("Laatste inspectiedatum > 1 jaar geleden")
        }
    }

    if (fireSecurityBuildingInfo.fireSecurityNextInspectionDate) {
        const nextInspectionDate = new Date(fireSecurityBuildingInfo.fireSecurityNextInspectionDate);
        if (now >= nextInspectionDate) {
            dotValues.red.count++;
            dotValues.red.labels.push("Volgende inspectiedatum is al gepasseerd")
        }
    }

    if (fireSecurityBuildingInfo.fireExtinguisherInElevatorRoomStatus === FireExtinguisherInElevatorRoomStatus.NO_ELEVATOR) {
        dotValues.green.count++;
        dotValues.green.labels.push("Geen lift in gebouw, dus geen brandblusser nodig")
    }
    if (fireSecurityBuildingInfo.fireExtinguisherInElevatorRoomStatus === FireExtinguisherInElevatorRoomStatus.OK)  {
        dotValues.green.count++;
        dotValues.green.labels.push("Brandblusser in liftkamer aanwezig")
    }
    if (fireSecurityBuildingInfo.fireProofDoors === FireProofDoorsStatus.OK)  {
        dotValues.green.count++;
        dotValues.green.labels.push("Brandwerende deuren ok")
    }
    if (fireSecurityBuildingInfo.fireProofDoors === FireProofDoorsStatus.NOT_REQUIRED)  {
        dotValues.green.count++;
        dotValues.green.labels.push("Brandwerende deuren niet vereist")
    }
    if (fireSecurityBuildingInfo.fireHoseReelStatus === FireHoseReelStatus.NOT_REQUIRED) {
        dotValues.green.count++;
        dotValues.green.labels.push("Brandhaspels niet vereist")
    }
    if (fireSecurityBuildingInfo.fireHoseReelStatus === FireHoseReelStatus.OK) {
        dotValues.green.count++;
        dotValues.green.labels.push("Brandhaspels ok")
    }
    if (fireSecurityBuildingInfo.fireEvacuationStatus === FireEvacuationStatus.OK)  {
        dotValues.green.count++;
        dotValues.green.labels.push("Evacuatieplannen en aanduidingen ok")
    }
    if (fireSecurityBuildingInfo.fireEvacuationStatus === FireEvacuationStatus.NOT_REQUIRED)  {
        dotValues.green.count++;
        dotValues.green.labels.push("Evacuatieplannen en aanduidingen niet vereist")
    }
    if (fireSecurityBuildingInfo && fireSecurityBuildingInfo.fireStairStatus && fireSecurityBuildingInfo.fireStairStatus === FireStairStatus.OK) {
        dotValues.transparent.count++;
        dotValues.transparent.labels.push("Brandtrap aanwezig");
    } 
    if (fireSecurityBuildingInfo.smokeDetectorsOnEveryFloorStatus === SmokeDetectorsOnEveryFloorStatus.OK)  {
        dotValues.green.count++;
        dotValues.green.labels.push("Rookdetectoren op elke verdieping ok")
    }
    if (fireSecurityBuildingInfo.emergencyLightingOnEveryFloorStatus === EmergencyLightingOnEveryFloorStatus.OK)  {
        dotValues.green.count++;
        dotValues.green.labels.push("Noodverlichting op elke verdieping ok")
    }
    if (fireSecurityBuildingInfo.emergencyLightingOnEveryFloorStatus === EmergencyLightingOnEveryFloorStatus.NOT_REQUIRED)  {
        dotValues.green.count++;
        dotValues.green.labels.push("Noodverlichting niet vereist")
    }
    if (fireSecurityBuildingInfo.fireExtinguisherOnEveryFloorStatus === FireExtinguisherOnEveryFloorStatus.OK)  {
        dotValues.green.count++;
        dotValues.green.labels.push("Brandblussers op elke verdieping ok")
    }
    if (fireSecurityBuildingInfo.inspectorResourceId)  {
        dotValues.green.count++;
        dotValues.green.labels.push("Keuringsorganisme laatste keuring gekend")
    }
    if (fireSecurityBuildingInfo.fireSecurityLastInspectionDate) {
        const lastInspectionDate = new Date(fireSecurityBuildingInfo.fireSecurityLastInspectionDate);
        if (lastInspectionDate < new Date() && lastInspectionDate > nineMonthsBefore)  {
            dotValues.green.count++;
            dotValues.green.labels.push("Laatste inspectiedatum voldoende recente")
        }
    }

    if (fireSecurityBuildingInfo.fireSecurityNextInspectionDate) {
        const expirationDate = new Date(fireSecurityBuildingInfo.fireSecurityNextInspectionDate);
        if (expirationDate > threeMonthsFromNow)  {
            dotValues.green.count++;
            dotValues.green.labels.push("Volgende inspectiedatum voldoende ver in de toekomst")
        }
    }

    return dotValues;
};
